import { Component, Input } from '@angular/core';

import { TextAndBlocksSectionCms } from '~/cms/interfaces/homepage.cms.interface';

import { ImageFormatVariantEnum } from './enums/image-format-variant.enum';

@Component({
  selector: 'app-cms-text-and-blocks-section',
  templateUrl: './text-and-blocks.component.html',
  styleUrls: ['./text-and-blocks.component.scss'],
})
export class CmsTextAndBlocksSectionComponent {
  @Input() public section: TextAndBlocksSectionCms;

  public get blockClass(): string {
    return `text-and-blocks-block--${this.section.block_variant}`;
  }

  public get blockContainerClass(): string {
    return this.section.blocks?.length === 2
      ? 'text-and-blocks__container--cols-2'
      : 'text-and-blocks__container--cols-3';
  }

  public get imageFormatVariant(): ImageFormatVariantEnum {
    return this.section.blocks?.length === 2
      ? ImageFormatVariantEnum.RECTANGLE
      : ImageFormatVariantEnum.DEFAULT;
  }

  public get variantClass(): string {
    return `text-and-blocks--background-${this.section.background_variant}`;
  }
}
